'use client';

import { Stack } from '@mui/material';
import type { ReactNode } from 'react';

import { campaignManagerTheme } from '@campaign-manager/theme';

import Prose from '../Prose';
import Title from '../Title';

interface Props {
  body?: ReactNode | string;
}

export default function TableErrorState({ body }: Props) {
  return (
    <Stack
      sx={{
        alignItems: 'start',
        alignContent: 'center',
        flexWrap: 'wrap',
        py: 4,
      }}
    >
      <Title
        size="sm"
        sx={{ color: campaignManagerTheme.color.error }}
      >
        Error
      </Title>
      {body && <Prose sx={{ textAlign: 'left', whiteSpace: 'pre-line' }}>{body}</Prose>}
    </Stack>
  );
}
